import React from 'react';
import { Navigate } from 'react-router-dom';
import LoginForm from './LoginForm.jsx';
import Navbar from "../Navbar.jsx";
import { useParams } from "react-router";
import PasswordRecovery from "./PasswordRecovery.jsx";
import {compareRole, iAmHigherAuthority} from "../../libs.jsx";
import './auth.css';
import { getSession, getCampusConfig } from "../../services/session";

const Landing = () => {

    let dData, bData, paramVars, container;

    paramVars = useParams();

    dData = getSession();

    if (paramVars?.dType === "recovery"){
        container = <PasswordRecovery />
    }else{
        container = <LoginForm />
    }

    /* Where "the alerts screen" actually is. A 5.0 campus serves it from
       /emergency (CloudAlerts) and a 4.0 campus from /alerts (Alerts) — both routes
       exist in the migrated route table (App.jsx), so sending a caregiver to the
       wrong one lands them on an empty page for their architecture.

       Same rule and same truthiness test NavigationV2 uses for its Active Alerts
       link, deliberately: if these two ever disagree, the nav highlights one screen
       while login drops you on the other. is_cloud reaches the session straight off
       the campus row (portal_session.py -> campusData), so it is 1, 0, null or
       false — all of which read correctly as plain truthiness.

       getCampusConfig() with no argument resolves the current campus (acnt) and is
       null-safe, so this is harmless on the logged-out render path below. */
    const alertsRoute = getCampusConfig()?.is_cloud ? "/emergency" : "/alerts";

    return (dData?.slauth !== true && (dData?.tKey == null || dData?.tkey === "")) ? (
        <div className="auth-page">
            <Navbar />
            <main className="auth-content">
                {container}
            </main>
        </div>
        ) : dData?.acnt != null
            ?   dData.migrated
                ?   iAmHigherAuthority(10, dData.role_weight) ?  <Navigate to={"/dash/main"} /> : <Navigate to={alertsRoute} />
                :   compareRole("caregiver", dData.userrole) ? <Navigate to={"/dash/main"} /> : <Navigate to={"/alerts/emergency"} />
            : <Navigate to={"/dash/null"} />
    };

export default Landing;
